import { Expand } from './Expand/Expand';
import { FadeIn } from './FadeIn/FadeIn';

export const Animation = {
  Expand,
  FadeIn,
};
